import React, { useState, useEffect } from "react";
import { Formik, Field } from "formik";
import { TitleText, LabelText } from "../../ui/Text";
import Input from "../../ui/Input";
import { Button } from "../../ui/Button";
import { LoginIcon } from "../../assets/svg/LoginIcon";
import styled from "styled-components";
import {
  useHistory,
  useParams,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import Axios from "axios";
import { PASSWORD_RESET_URL, USER_URL } from "../../api/urls";
import { get } from "../../utils/get";
import { postEndpoint } from "../../api/api";
import Form, { InputSection } from "../settings/components/Form";
import * as yup from "yup";
import queryString from "query-string";
import { BASE_API_URL, BASE_URL } from "../../utils/app-constants";
import { toast } from "react-toastify";
const PasswordUpdateSchema = yup.object().shape({
  password: yup
    .string()
    .label("Password")
    .required()
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),
    // .min(2, "password too short...")
    // .max(10, "Your password must be a maximum of 10 characters."),
  confirm_password: yup
    .string()
    .required()
    .label("Confirm password")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

export const ResetPassword = (props) => {
  const [token, setToken] = useState<any>("");
  const [postRes, postReq] = postEndpoint();
  const [userInfo, setUserInfo] = useState([]);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const { token } = queryString.parse(location.search);
    setToken(token);
    // remove token from url to prevent http referer leakage
    console.log(token);
  }, []);
  useEffect(() => {
    if (token) {
      const payload = {
        token,
        should_expire_token: true,
      };
      Axios.post(`${BASE_API_URL}/auth/password/token-authenticate`, payload)
        .then((response) => {
          setUserInfo(response.data);
          toast.success(
            "Your token has been verified successfully. Kindly reset your password."
          );
        })
        .catch((error) => {
          toast.error(
            get(error, "response.data.message", "Your token may have expired.")
          );
        });
    }
  }, [token]);
  const sendResetPasswordEmail = (values) => {
    const payload = {
      email: get(values, "email"),
      // base_reset_url: `${BASE_URL}/resetPassword`,
    };
    Axios.post(`${PASSWORD_RESET_URL}`, payload)
      .then((res) => {
        console.log(res.data);
        toast.success(
          "Kindly click on the reset link that was sent to the email you provided."
        );
      })
      .catch((error) => {
        toast.error(get(error, "response.data.message"));
      });
  };
  const handlePasswordUpdate = (values) => {
    let token = get(userInfo, "access_token");
    let userId = get(userInfo, "user.id");
    const payload = {
      password: get(values, "password"),
    };
    Axios.put(`${USER_URL}/${userId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        toast.success("Password has been successfully reset. Please Log in.");
        history.push("/login");
      })
      .catch((error) => {
        toast.error(get(error, "response.data.message"));
      });
  };
  return (
    <Container>
      <LoginContainer>
        {token ? (
          <Formik
            validationSchema={PasswordUpdateSchema}
            initialValues={{ passowrd: "", confirm_password: "" }}
            onSubmit={(values) => handlePasswordUpdate(values)}
          >
            {({ handleSubmit }) => (
              <LoginForm>
                <TitleText style={{ marginBottom: 30, fontSize: 24 }}>
                  Enter new password
                </TitleText>
                <InputSection>
                  <Field
                    type="password"
                    name="password"
                    component={Input}
                    label="Password"
                    // width="47%"
                  />
                </InputSection>
                <InputSection>
                  <Field
                    type="password"
                    name="confirm_password"
                    component={Input}
                    label=" Confirm Password"
                  />
                </InputSection>
                <Button
                  text="Reset"
                  // @ts-ignore
                  style={{
                    width: "100%",
                    alignSelf: "flex-end",
                    marginTop: 40,
                    marginBottom: 40,
                  }}
                  onClick={() => handleSubmit()}
                />
                <div
                  style={{
                    width: "100%",
                    borderBottomWidth: 1,
                    borderBottomStyle: "solid",
                    borderBottomColor: "#EEEFFF",
                    marginBottom: 30,
                  }}
                />
                <TitleText style={{ fontWeight: 400 }}>
                  Need help?{"  "}
                  <span style={{ color: "#01A8CE", fontWeight: 500 }}>
                    Contact support
                  </span>
                </TitleText>
              </LoginForm>
            )}
          </Formik>
        ) : (
          <Formik
            initialValues={{ email: "" }}
            onSubmit={(values) => sendResetPasswordEmail(values)}
          >
            {({ handleSubmit }) => (
              <LoginForm>
                <TitleText style={{ marginBottom: 30, fontSize: 24 }}>
                  Reset password
                </TitleText>
                <LabelText style={{ marginBottom: 30 }}>
                  Please enter your account email address. We will send you
                  instructions for resetting your password
                </LabelText>
                <Field name="email" component={Input} label="Email address" />
                <Button
                  text="Send"
                  // @ts-ignore
                  style={{
                    width: "100%",
                    alignSelf: "flex-end",
                    marginTop: 40,
                    marginBottom: 40,
                  }}
                  onClick={() => handleSubmit()}
                />
                <div
                  style={{
                    width: "100%",
                    borderBottomWidth: 1,
                    borderBottomStyle: "solid",
                    borderBottomColor: "#EEEFFF",
                    marginBottom: 30,
                  }}
                />
                <TitleText style={{ fontWeight: 400 }}>
                  Need help?{"  "}
                  <span style={{ color: "#01A8CE", fontWeight: 500 }}>
                    Contact support
                  </span>
                </TitleText>
              </LoginForm>
            )}
          </Formik>
        )}

        <LoginIcon />
      </LoginContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  min-height: 100%;
  height: 100vh;
  background-color: #f5f6fb;
`;

const LoginContainer = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 5em;
`;

const LoginForm = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 2em;
  width: 60%;
  height: 70%;
  border-radius: 30px;
  /* ${TitleText} {
    color: #01A8CE;
  } */
`;
